import { createApp, h, onBeforeMount } from 'vue';
import { useStore } from '@components/common/store';
import { determinePageType } from '@utils/utils';
import { mountReplace } from '@/js/utils/mountUtils';
import RegionList from './RegionList.vue';

const pageType = determinePageType();
const mountPoint = document.querySelector('#region-list');

const initRegionList = (): void => {
	const dataset = document.getElementById('region-list-data')?.dataset;

	const displaymode = dataset?.displaymode ?? 'overview';
	const rlId = dataset?.rlId ?? '';
	const countryCode = dataset?.countryCode ?? '';

	if (!dataset) {
		return;
	}

	const store = useStore();

	const RegionListApp = createApp({
		name: 'RegionList',
		setup() {
			onBeforeMount(() => {
				if (!store.state.config.storeInitialized) {
					store.dispatch('initStore', dataset);
				}
			});
		},
		render: () =>
			h(RegionList, {
				displaymode,
				rlId,
				countryCode,
			}),
	});

	mountReplace(RegionListApp, mountPoint!);
};

if (pageType === 'regionList' && mountPoint) {
	initRegionList();
}
